import { useParams } from "react-router-dom";
import { useState } from "react";
import { MindSnapView } from "../views/mindSnapView";
import locationTask from "../data/locationTask.json";
import { updateProgressReduxCB } from "../util/helpersFunction.js";
import images from "../images/images.js";

function MindSnap() {
  const { mode, id } = useParams();
  const location = locationTask[id];
  const title = location?.title;
  const questionData = location?.[`${mode}Question`];
  const imageKey = `drawing_${id}`;
  const answerLabels = ["A", "B", "C", "D"];
  const quest = "mindSnap";
  const [answered, setAnswered] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [currentStep, setCurrentStep] = useState(3);


  if (!questionData) {
    return <div>No question available for this mode.</div>;
  }

  function handleAnswerClickACB(choice) {
    const { correctAnswer, correctComment, incorrectComment } = questionData;
    const isRight = choice === correctAnswer;

    console.log(isRight);
    
    
   

    setAnswered(true);
    setFeedback(isRight ? (correctComment || "Correct!") : (incorrectComment || "Incorrect!"));
    setCurrentStep(4); 

    const status = isRight ? "success" : "fail";
    updateProgressReduxCB(id, mode, status, quest);
  }

  function handleGoToModeInfoACB() {
    window.location.hash = `#/questComplete/${id}/${mode}/${quest}`;
  }

  return (
    <MindSnapView
      location={location}
      mode={mode}
      title={title}
      questionData={questionData}
      onAnswer={handleAnswerClickACB}
      images={images}
      currentStep={currentStep}
      answered={answered}
      onComplete={handleGoToModeInfoACB}
      imageKey={imageKey}
      answerLabels={answerLabels}
      feedback={feedback}
    />
  );
}

export { MindSnap };
